import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Save, Bell } from "lucide-react";

const AdminSettings = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => {
      const data = r.data;
      data.delivery_zones = Array.isArray(data.delivery_zones)
        ? data.delivery_zones.join(", ")
        : data.delivery_zones || "";
      setForm(data);
    });
  }, []);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setForm((f) => ({ ...f, [name]: type === "number" ? parseFloat(value) || 0 : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    const payload = {
      ...form,
      delivery_zones: form.delivery_zones.split(",").map((z) => z.trim()).filter(Boolean),
    };
    await api.put("/admin/settings", payload);
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  if (!form) return <div className="text-gray-500">Chargement…</div>;

  return (
    <div data-testid="admin-settings-page">
      <p className="eyebrow mb-2">Configuration</p>
      <h1 className="font-display text-4xl text-white leading-none mb-8">
        <span className="italic text-gold">Paramètres</span>
      </h1>

      <form onSubmit={handleSubmit} className="bg-night-2 border border-subtle p-6 sm:p-10 max-w-3xl space-y-8" data-testid="settings-form">
        <div>
          <p className="eyebrow mb-5 flex items-center gap-2"><Bell size={12} /> Notifications</p>
          <p className="text-xs text-gray-500 mb-5">
            Numéro et email où vous souhaitez recevoir les nouvelles commandes. (Integration SMS/Email à venir)
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">Téléphone propriétaire</label>
              <input name="owner_phone" value={form.owner_phone} onChange={handleChange} className="input-line" placeholder="+33 6 12 34 56 78" data-testid="owner-phone-input" />
            </div>
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">Email propriétaire</label>
              <input name="owner_email" type="email" value={form.owner_email} onChange={handleChange} className="input-line" placeholder="owner@noctua.fr" data-testid="owner-email-input" />
            </div>
          </div>
        </div>

        <div>
          <p className="eyebrow mb-5">Livraison</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">Frais de livraison (€)</label>
              <input type="number" step="0.5" name="delivery_fee" value={form.delivery_fee} onChange={handleChange} className="input-line" data-testid="delivery-fee-input" />
            </div>
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">Commande minimum (€)</label>
              <input type="number" step="0.5" name="min_order" value={form.min_order} onChange={handleChange} className="input-line" data-testid="min-order-input" />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">Horaires</label>
              <input name="open_hours" value={form.open_hours} onChange={handleChange} className="input-line" placeholder="22:00 - 05:00" />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">Zones (séparées par virgules)</label>
              <input name="delivery_zones" value={form.delivery_zones} onChange={handleChange} className="input-line" />
            </div>
          </div>
        </div>

        <div>
          <p className="eyebrow mb-5">Réseaux</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">Instagram</label>
              <input name="instagram" value={form.instagram} onChange={handleChange} className="input-line" placeholder="@noctua.riviera" />
            </div>
            <div>
              <label className="text-xs text-gray-500 uppercase tracking-wider mb-1 block">WhatsApp</label>
              <input name="whatsapp" value={form.whatsapp} onChange={handleChange} className="input-line" />
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4 pt-5 border-t border-subtle">
          <button type="submit" disabled={saving} className="btn-gold" data-testid="settings-save-btn">
            <Save size={14} /> {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
          {saved && <span className="text-emerald-400 text-sm" data-testid="settings-saved-msg">Paramètres enregistrés ✓</span>}
        </div>
      </form>
    </div>
  );
};

export default AdminSettings;
